"use client";
import Image from "next/image";
import {useState} from "react";
import {OutputResult} from "./leftWidgets/outputResult";
import {RoutesHistory} from "./rightWidgets/routeChangeHistory";
type TabList = "outputResult" | "history";
export const RoutesRightBar = function () {
  const [selectedTab, setSeleltedTab] = useState<TabList | null>(
    "outputResult"
  );

  return (
    <>
      <div className="absolute right-1 top-2 z-10 h-[25%] w-10 rounded bg-white bg-opacity-90 p-2 shadow-md">
        <div className="flex flex-col items-center gap-4">
          <Image
            src={`/icons/routePlan/outputResult.svg`}
            className="cursor-pointer"
            alt={"Output Result"}
            onClick={() => setSeleltedTab("outputResult")}
            width={15}
            height={15}
            //className="mb-4"
          />
          {/* Will enable later */}
          <Image
            src={`/icons/routePlan/history.svg`}
            className="cursor-pointer"
            alt={"History"}
            onClick={() => setSeleltedTab("history")}
            width={15}
            height={15}
            //className="mb-4"
          />
        </div>
      </div>
      {selectedTab === "history" ? (
        <RoutesHistory />
      ) : selectedTab === "outputResult" ? (
        <OutputResult setSeleltedTab={setSeleltedTab} />
      ) : null}
    </>
  );
};
